import { render, staticRenderFns } from "./product-details-general-api-handler.vue?vue&type=template&id=2d169b17&"
import script from "./product-details-general-api-handler.vue?vue&type=script&lang=js&"
export * from "./product-details-general-api-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports